export default {
    add_to_egisz: "EGISZga qo'shing",
    comment_to_deal: "Amal uchun izoh",
    diagnosis_comments: "Diagnozga izohlar",
    download_all: "Barchasini yuklab oling",
    edit_patient: "Bemorni tahrirlash",
    egisz: "EGISZ",
    for_rework: "Qayta ko'rib chiqish uchun",
    funnel: "Kanban",
    go_to_egisz_page: "Yagona davlat sog'liqni saqlash axborot tizimi sahifasiga o'ting",
    list: "Ro'yxat",
    main_doctor: "Bosh shifokor",
    patient_rejected_to_send_to_egisz: "Bemor EGISZ ga ma'lumotlarni yuborishdan bo'shadi",
    prepare_document_for_sending_to_egisz: "Hujjatni EGISZ ga yuborish uchun tayyorlang?",
    processing_status: "Ishlovchi holati",
    representative_relation: "Bemorga vakil bo'lgan shaxs",
    requires_attention: "E'tibor kerak",
    send_all: "Barchasini yuboring",
    send_to_egisz: "EGISZ ga yuboring",
    sent_to_egisz: "EGISZ ga yuborildi",
    show_more: "Ko'proq ko'rsatish",
    show_only_not_sent: "Faqat yuborilmaganlarini ko'rsatish",
    sign: "Imzo",
    sign_all: "Barchasini imzolash",
    signed_by_doctor: "Shifokor tomonidan imzolangan",
    signed_by_main_doctor: "Imzolangan bo'lim. shifokor",
    to_egisz_page: "EGISZ sahifasiga",
    to_rework: "Qayta ko'rib chiqish uchun",
    to_sign: "Imzo yo'q"
}
